// extracted by mini-css-extract-plugin
module.exports = {"container":"UxLFF2fC1Ecjz_Fjgd54b"};